(function () {
  function closeAll(except) {
    document.querySelectorAll('.ai-image-badge.is-open').forEach(function (badge) {
      if (badge === except) return;
      badge.classList.remove('is-open');
      var trigger = badge.querySelector('.ai-image-badge__trigger');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('.ai-image-badge__trigger');
    if (trigger) {
      event.preventDefault();
      event.stopPropagation();
      var badge = trigger.closest('.ai-image-badge');
      var willOpen = !badge.classList.contains('is-open');
      closeAll(badge);
      badge.classList.toggle('is-open', willOpen);
      trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      return;
    }

    if (!event.target.closest('.ai-image-badge')) {
      closeAll();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAll();
  });
})();
